<script lang="ts">
  import type { Snippet } from "svelte";
  import type { HTMLAttributes } from "svelte/elements";
  import type { Except } from "type-fest";

  interface Props extends Except<HTMLAttributes<HTMLDivElement>, "title"> {
    showActions?: boolean;
    title?: Snippet;
    description?: Snippet;
    actions?: Snippet;
  }

  let {
    showActions = true,
    title,
    description,
    children,
    actions,
    class: className,
    ...rest
  }: Props = $props();
</script>

<div
  {...rest}
  class={[
    "flex flex-col gap-6 overflow-hidden rounded-xl bg-mono-000 p-6 shadow-border-inset",
    className,
  ]}
>
  <div class="flex flex-1 flex-col gap-3">
    {#if title || description}
      <div class="flex flex-col gap-1">
        {#if title}
          <div class="title text-base">
            {@render title?.()}
          </div>
        {/if}
        {#if description}
          <p class="text-sm text-foreground-secondary">
            {@render description?.()}
          </p>
        {/if}
      </div>
    {/if}

    <div class="flex-1 text-sm">
      {@render children?.()}
    </div>
  </div>

  {#if actions && showActions}
    <div class="flex gap-2">
      {@render actions?.()}
    </div>
  {/if}
</div>

<style>
  @reference "#tailwind.css";
  .title {
    :global(h1),
    :global(h2),
    :global(h3),
    :global(h4) {
      @apply font-serif text-2xl text-foreground-primary;
    }
  }
</style>
